/**
 * Etiquetas del filtro "Tipo de fecha" de los reportes de producción — la
 * columna de la prescripción sobre la que aplica el rango `dateFrom`/`dateTo`.
 */
export const DATE_TYPE_LABELS: Record<string, string> = {
  dateOfProduction: 'Fecha de producción',
  date: 'Fecha de creación',
  administrationDate: 'Fecha de administración',
};

export const DEFAULT_DATE_TYPE = 'dateOfProduction';
